import Language from '../v2/lang/language';

export default class Address {
  constructor(address) {
    this.addressId = address.addressId;
    this.legacyId = address.legacyId || '';
    this.addressee = address.addressee;
    this.companyName = address.companyName || address.organisationName;
    this.nameNumber = address.nameNumber || address.buildingNameNumber;
    this.streetName = address.streetName || address.line1;
    this.addressLine2 = address.addressLine2 || address.line2;
    this.townCity = address.townCity || address.line3;
    this.county = address.county || address.line4;
    this.postCode = address.postCode || address.postcode;
    this.countryName = address.countryName || Language.getCountryName(address.countryCode || address.country);
    this.countryCode = address.countryCode || address.country;
    this.contactNumber = address.contactNumber;
    this.addressNickname = address.addressNickname;
  }
  
  static addressLine(value) {
    return value ? (
      <span>
        {value}
        <br />
      </span>
    ) : null;
  }
  
  static addComma(value) {
    return value ? `${value}, ` : '';
  }
  
  getAddressString() {
    if (this.addressNickname) {
      return `${Address.addComma(this.addressee)}${this.nameNumber ? `${this.nameNumber} ` : ''}${Address.addComma(this.streetName)}${Address.addComma(this.addressLine2)}${Address.addComma(this.townCity)}${Address.addComma(this.county)}${Address.addComma(this.postCode)}${this.countryName}`;
    }
    return `${this.nameNumber ? `${this.nameNumber} ` : ''}${Address.addComma(this.streetName)}${Address.addComma(this.addressLine2)}${Address.addComma(this.townCity)}${Address.addComma(this.county)}${Address.addComma(this.postCode)}${this.countryName}`;
  }
  
  lineFormat() {
    if (this.addressNickname) {
      return (
        <p>
          <span className="addressee">
            {Address.addressLine(this.addressNickname)}
          </span>
          <span className="address">
            {Address.addressLine(this.addressee)}
            {Address.addressLine(this.companyName)}
            {Address.addressLine(this.nameNumber)}
            {Address.addressLine(this.streetName)}
            {Address.addressLine(this.addressLine2)}
            {Address.addressLine(this.townCity)}
            {Address.addressLine(this.county)}
            {Address.addressLine(this.postCode)}
            {Address.addressLine(this.countryName)}
          </span>
        </p>
      );
    }
    return (
      <p>
        <span className="addressee">
          {Address.addressLine(this.addressee)}
        </span>
        <span className="address">
          {Address.addressLine(this.companyName)}
          {Address.addressLine(this.nameNumber)}
          {Address.addressLine(this.streetName)}
          {Address.addressLine(this.addressLine2)}
          {Address.addressLine(this.townCity)}
          {Address.addressLine(this.county)}
          {Address.addressLine(this.postCode)}
          {Address.addressLine(this.countryName)}
        </span>
      </p>
    );
  }
  
  shortenedAddressString() {
    return `${this.getAddressString().substring(0, 50)} ...`;
  }
  
  shortenedLineFormat() {
    if (this.addressNickname) {
      return (
        <p>
          <span className="addressee">
            {Address.addressLine(this.addressNickname)}
          </span>
          <span className="address">
            {this.shortenedAddressString()}
          </span>
        </p>
      );
    }
    return (
      <p>
        <span className="addressee">
          {Address.addressLine(this.addressee)}
        </span>
        <span className="address">
          {this.shortenedAddressString()}
        </span>
      </p>
    );
  }
}
